// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","549":"component---src-templates-docs-js"}[chunkId] || chunkId) + "-" + {"125":"7a2c6dcc239299007008","223":"7192071afd627e5381bb","471":"14ab6dd17e8cc356b807","549":"41f26e5d48c2fa244570"}[chunkId] + ".js";
};